import React, { createContext, useContext, ReactNode } from "react";
import { useConfigurator } from "./useConfigurator";
import { Section, Callbacks, ConfiguratorContextType } from "./types";

const ConfiguratorContext = createContext<ConfiguratorContextType | undefined>(
  undefined
);

export const useConfiguratorContext = (): ConfiguratorContextType => {
  const context = useContext(ConfiguratorContext);

  if (!context) {
    throw new Error(
      "useConfiguratorContext must be used within a ConfiguratorProvider"
    );
  }
  return context;
};

export const ConfiguratorProvider = ({
  sections,
  configuratorName,
  children,
}: {
  sections: Section[];
  configuratorName: string;
  children: ReactNode;
}) => {
  const configurator = useConfigurator(sections);

  return (
    <ConfiguratorContext.Provider value={{ ...configurator, configuratorName }}>
      {children}
    </ConfiguratorContext.Provider>
  );
};
